var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","text":"","small":""},on:{"click":_vm.show}},[_vm._v("Details")])
}
var staticRenderFns = []

export { render, staticRenderFns }